"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _styles = require("@material-ui/core/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _excluded = ["disableHover"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      padding: 0,
      color: function color(props) {
        if (props.darkColor) {
          return _pittaModules.DarkColors.primary["1"];
        } else if (props.color === "secondary") {
          return _pittaModules.LightColors.primary["3"];
        } else if (props.color === "primary") {
          return _pittaModules.LightColors.primary["0"];
        } else {
          return _pittaModules.LightColors.primary["1"];
        }
      },
      // color: LightColors.primary["1"],
      "&:hover": {
        color: function color(props) {
          if (props.disableHover) {
            return undefined;
          }
          return _pittaModules.LightColors.primary["7"];
        },
        backgroundColor: "transparent"
      },
      "&:active": {
        color: _pittaModules.LightColors.primary["7"]
      }
    },
    colorSecondary: {
      color: _pittaModules.LightColors.primary["3"],
      "&:hover": {
        color: function color(props) {
          if (props.disableHover) {
            return undefined;
          }
          return _pittaModules.LightColors.primary["1"];
        },
        backgroundColor: "transparent"
      },
      "&:active": {
        color: _pittaModules.LightColors.primary["1"]
      }
    },
    colorPrimary: {
      color: _pittaModules.LightColors.primary["0"],
      "&:hover": {
        color: function color(props) {
          if (props.disableHover) {
            return undefined;
          }
          return _pittaModules.LightColors.primary["7"];
        },
        backgroundColor: "transparent"
      },
      "&:active": {
        color: _pittaModules.LightColors.primary["7"]
      }
    }
  };
});
var IconButton = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = useStyle(props);
  var disableHover = props.disableHover,
    restProps = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_react.default.createElement(_core.IconButton, _extends({
    ref: ref,
    classes: classes
  }, restProps, {
    disableRipple: true,
    disableFocusRipple: true
  }));
});
exports.IconButton = IconButton;